<div class="{{free ? 'no-data' : 'no-data position-absolute'}}">
        <img src="assets/images/no-data.png" alt="No data"/>
        <h4 class="title">No {{title}} found {{applied ? 'based on your filters criteria.' : '.'}}</h4>
        <p class="sub-title">There is no data to show you right now.</p>
    </div>